import React from 'react';
import exportImage from './img/export.jpg'
import importImage from './img/import.jpg'
import specialsImage from './img/specials.jpg'
import ArgentinaMap from './ArgentinaMap';
import AreaTitle from './AreaTitle';

import CordobaColor from './img/cordoba-color.png'
import SantaFeColor from './img/santa-fe-color.png'
import MendozaColor from './img/mendoza-color.png'
import BairesColor from './img/baires-color.png'
import CorrientesColor from './img/corrientes-color.png'
import ServiceLocation from './ServiceLocation';
import specialsGrayscale from './img/specials-grayscale.jpg'


const Service = () => {

  return (
  <section className="service-area-three section-padding" id="services-link">
        <div className="container">
            <div className="row">
                <div className="col-xs-12">
                <AreaTitle title="Nuestros servicios">
                  </AreaTitle>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <p style={{textAlign: 'center'}}>A fin de brindar un servicio integral contamos con representaciones en distintas aduanas del país</p>

                    <div className="row" style={{ paddingTop: 50 }}>
                      {
                        [{
                          location: 'Córdoba - General Deheza',
                          locationImage: CordobaColor
                        },
                        {
                          location: 'Mendoza - Mendoza',
                          locationImage: MendozaColor
                        },
                        {
                          location: 'Corrientes - Paso de los Libres',
                          locationImage: CorrientesColor
                        },
                        {
                          location: 'Santa Fé - Rosario',
                          locationImage: SantaFeColor
                        },
                        {
                          location: 'Buenos Aires - Ezeiza',
                          locationImage: BairesColor
                        }].map((l) => <ServiceLocation {...l}></ServiceLocation>)
                      }
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 hidden-xs hidden-sm wow slideInRight" id="argentina-map" style={{textAlign: 'center' }}>
                  <ArgentinaMap></ArgentinaMap>
                </div>
            </div>

            <div id="export-link" className="row service-container" style={{ paddingTop: 30 }}>
              <div className="col-md-4 service-left-panel-export hidden-xs hidden-sm" style={{alignSelf: 'center', textAlign: 'center'}}>
                <h1>Exportación</h1>
              </div>
              <div className="col-xs-12 col-md-8" style={{ padding: 50 }}>
              <div className="row visible-xs visible-sm wow fadeIn" style={{ paddingBottom: 30 }}>
                      <div className="col-xs-12"><h1 style={{ textAlign: 'center' }}><i className="fa fa-plane"/></h1></div>
                      <div className="col-xs-12"><h1  style={{ textAlign: 'center' }}>Exportación</h1></div>
              </div>
              <ul className="fa-ul wow fadeIn">
                  <li><i className="fa-li fa fa-check-square"></i>Confección y tramitación del Permiso de Embarque (Gestión aduanera)</li>
                  <li><i className="fa-li fa fa-check-square"></i>Confección de documentación (Factura Comercial, Certificado de Origen, Conocimiento de Embarque y Manifiesto de Carga).</li>
                  <li><i className="fa-li fa fa-check-square"></i>Servicio de Agente de Transporte Aduanero para sus cargas.</li>
                  <li><i className="fa-li fa fa-check-square"></i>Gestión ante organismos oficiales.</li>
                  <li><i className="fa-li fa fa-check-square"></i>Seguimiento de descarga de ROE VERDE.</li>
                  <li><i className="fa-li fa fa-check-square"></i>Seguimiento y pago de derechos a la exportación.</li>
                  <li><i className="fa-li fa fa-check-square"></i>Tramitación y cobro de reintegros a las exportaciones.</li>
                  <li><i className="fa-li fa fa-check-square"></i>Seguimiento de descarga de las importaciones temporales.</li>
                  <li><i className="fa-li fa fa-check-square"></i>Seguimiento de regímenes especiales (envíos en consignación, sutituciones).</li>
                  <li><i className="fa-li fa fa-check-square"></i>Coordinación de cargas en contenedores en Puerto de Buenos Aires y envíos aéreos por aeropuerto de Ezeiza.</li>
                  <li><i className="fa-li fa fa-check-square"></i>Informes diarios de los distintos cambios que se producen en materia de comercio exterior.</li>
                  <li><i className="fa-li fa fa-check-square"></i>Confección de embalajes de madera a medida.</li>
                  <li><i className="fa-li fa fa-check-square"></i>Servicio de tratamiento de embalajes según requisitos de EE.UU y UE.</li>
                </ul>
              </div>
            </div>
            <div id="import-link" className="row service-container">
              <div className="col-md-4 service-left-panel-import hidden-xs hidden-sm" style={{alignSelf: 'center', textAlign: 'center'}}>
                <h1>Importación</h1>
              </div>
              <div className="col-xs-12 col-md-8" style={{ padding: 50 }}>
              <div className="row visible-xs visible-sm wow fadeIn" style={{ paddingBottom: 30 }}>
                      <div className="col-xs-12"><h1 style={{ textAlign: 'center' }}><i className="fa fa-ship"/></h1></div>
                      <div className="col-xs-12"><h1  style={{ textAlign: 'center' }}>Importación</h1></div>
              </div>
              <ul className="fa-ul wow fadeIn">
                <li><i className="fa-li fa fa-check-square"></i>Confección y tramitación del Despacho de Importación (Gestión aduanera).</li>
                <li><i className="fa-li fa fa-check-square"></i>Pago por vuestra cuenta y orden de los Derechos y tasas de importación, almacenajes y fletes.</li>
                <li><i className="fa-li fa fa-check-square"></i>Coordinación y seguimiento de su mercadería.</li>
                <li><i className="fa-li fa fa-check-square"></i>Manejo logístico de stock de piezas, con información diaria de estado de las mismas.</li>
                <li><i className="fa-li fa fa-check-square"></i>Coordinación con los demás sujetos que interviene en un operativo a los fines de optimizar costos y tiempo.</li>
                <li><i className="fa-li fa fa-check-square"></i>Manejo integral de importación temporarias con asesoramiento permanente para el uso racional de las herramientas legales en dicha materia.</li>
                <li><i className="fa-li fa fa-check-square"></i>Visitas periódicas a conveniencia de la empresa a los fines de optimizar el servicio.</li>
                <li><i className="fa-li fa fa-check-square"></i>Asesoramiento integral en materia aduanera, organismos oficiales y privados.</li>
                <li><i className="fa-li fa fa-check-square"></i>Gestión para solicitar Certificados de Tipificación ante la Secretaria de Industria.</li>
                <li><i className="fa-li fa fa-check-square"></i>Servicio de Agente de Agente de Transporte Aduanero para sus cargas.</li>
                <li><i className="fa-li fa fa-check-square"></i>Contratación por cuenta y orden de seguros y cauciones.</li>
                <li><i className="fa-li fa fa-check-square"></i>Informes de costos.</li>
                <li><i className="fa-li fa fa-check-square"></i>Informes diarios de los distintos cambios que se producen en materia de comercio exterior.</li>
                <li><i className="fa-li fa fa-check-square"></i>Servicio de fletes internos.</li>
                </ul>
              </div>
            </div>

            <div id="special-link" className="row service-container">
              <div className="col-md-4 service-left-panel-special hidden-xs hidden-sm" style={{alignSelf: 'center', textAlign: 'center'}}>
                <h1>Especiales</h1>
              </div>
              <div className="col-xs-12 col-md-8" style={{ padding: 50 }}>
              <div className="row visible-xs visible-sm wow fadeIn" style={{ paddingBottom: 30 }}>
                      <div className="col-xs-12"><h1 style={{ textAlign: 'center' }}><i className="fa fa-star"/></h1></div>
                      <div className="col-xs-12"><h1  style={{ textAlign: 'center' }}>Especiales</h1></div>
              </div>
                <ul className="fa-ul wow fadeIn">
                  <li><i className="fa-li fa fa-check-square"></i>Toda intervención extra-aduanera relacionada con el comercio exterior, por ejemplo: Seguridad eléctrica, INAL, SENASA, ANMAT, FLORA, FAUNA, INASE, etc.</li>
                  <li><i className="fa-li fa fa-check-square"></i>Mudanzas internacionales, representación como Agentes de Transporte (empresas nacionales e internacionales).</li>
                </ul>
              </div>
            </div>
            
            {/* <div className="row" id="export-link">
              <div className="col-md-12">
                <div className="single-blog wow fadeIn" style={{ visibility: 'visible' }}>
                            <div className="blog-image" style={{ maxHeight: 400 }}>
                                <img className="img-responsive" src={exportImage} alt="" />
                            </div>
                            <div className="blog-details">
                                <div className="blog-meta"><a><i className="fa fa-plane"></i></a></div>
                                <h3><a>Servicios para exportación</a></h3>
                                <ul className="fa-ul">
                                  <li><i className="fa-li fa fa-check-square" />Confección y tramitación del Permiso de Embarque (Gestión aduanera)</li>
                                  <li><i className="fa-li fa fa-check-square" />Confección de documentación (Factura Comercial, Certificado de Origen, Conocimiento de Embarque 
                                      y Manifiesto de Carga).</li>
                                  <li><i className="fa-li fa fa-check-square" />Servicio de Agente de Transporte Aduanero para sus cargas.</li>
                                  <li><i className="fa-li fa fa-check-square" />Gestión ante organismos oficiales.</li>
                                  <li><i className="fa-li fa fa-check-square" /> Seguimiento de descarga de ROE VERDE.</li>
                                  <li><i className="fa-li fa fa-check-square" /> Seguimiento y pago de derechos a la exportación.</li>
                                  <li><i className="fa-li fa fa-check-square" /> Tramitación y cobro de reintegros a las exportaciones.</li>
                                  <li><i className="fa-li fa fa-check-square" /> Seguimiento de descarga de las importaciones temporales.</li>
                                  <li><i className="fa-li fa fa-check-square" /> Seguimiento de regímenes especiales (envíos en consignación, sutituciones).</li>
                                  <li><i className="fa-li fa fa-check-square" /> Coordinación de cargas en contenedores en Puerto de Buenos Aires y envíos aéreos 
                                        por aeropuerto de Ezeiza.</li>
                                  <li><i className="fa-li fa fa-check-square" /> Informes diarios de los distintos cambios que se producen en materia de comercio exterior.</li>
                                  <li><i className="fa-li fa fa-check-square" /> Confección de embalajes de madera a medida.</li>
                                  <li><i className="fa-li fa fa-check-square" /> Servicio de tratamiento de embalajes según requisitos de EE.UU y UE.</li>
                                </ul>
                            </div>
                        </div>
                </div>
            </div>

            <div className="row" style={{ paddingTop: 40 }} id="import-link">
              <div className="col-md-12">
                <div className="single-blog wow fadeIn" style={{ visibility: 'visible' }}>
                            <div className="blog-image" style={{ maxHeight: 400 }}>
                                <img className="img-responsive" src={importImage} alt="" />
                            </div>
                            <div className="blog-details">
                                <div className="blog-meta"><a><i className="fa fa-ship"></i></a></div>
                                <h3><a>Servicios para importación</a></h3>
                                <ul className="fa-ul">
                                  <li><i className="fa-li fa fa-check-square"></i>Confección y tramitación del Despacho de Importación (Gestión aduanera).</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Pago por vuestra cuenta y orden de los Derechos y tasas de importación, almacenajes y fletes.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Coordinación y seguimiento de su mercadería.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Manejo logístico de stock de piezas, con información diaria de estado de las mismas.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Coordinación con los demás sujetos que interviene en un operativo a los fines de optimizar costos y tiempo.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Manejo integral de importación temporarias con asesoramiento permanente para el uso racional de las herramientas legales en dicha materia.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Visitas periódicas a conveniencia de la empresa a los fines de optimizar el servicio.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Asesoramiento integral en materia aduanera, organismos oficiales y privados.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Gestión para solicitar Certificados de Tipificación ante la Secretaria de Industria.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Servicio de Agente de Agente de Transporte Aduanero para sus cargas.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Contratación por cuenta y orden de seguros y cauciones.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Informes de costos.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Informes diarios de los distintos cambios que se producen en materia de comercio exterior.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Servicio de fletes internos.</li>
                                </ul>
                            </div>
                        </div>
                </div>
            </div>

            <div className="row" style={{ paddingTop: 40 }} id="special-link">
              <div className="col-md-12">
                <div className="single-blog wow fadeIn" style={{ visibility: 'visible' }}>
                            <div className="blog-image" style={{ maxHeight: 400 }}>
                                <img className="img-responsive" src={specialsImage} alt="" />
                            </div>
                            <div className="blog-details">
                                <div className="blog-meta"><a><i className="fa fa-star"></i></a></div>
                                <h3><a>Servicios especiales</a></h3>
                                <ul className="fa-ul">
                                  <li><i className="fa-li fa fa-check-square"></i>Toda intervención extra-aduanera relacionada con el comercio exterior, por ejemplo: Seguridad eléctrica, INAL, SENASA, ANMAT, FLORA, FAUNA, INASE, etc.</li>
                                  <li><i className="fa-li fa fa-check-square"></i>Mudanzas internacionales, representación como Agentes de Transporte (empresas nacionales e internacionales).</li>
                                </ul>
                            </div>
                        </div>
                </div>
            </div> */}
        </div>
    </section>
)
                    }

export default Service